<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    },
    components: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {

    },
}

</script>
<style scoped lang='scss'>
</style>